<template>

    <div>

        <!-- Table Container Card -->
        <b-card
            no-body
            class="mb-0">

            <div class="m-2">

                <!-- Table Top -->
                <b-row>

                    <!-- Per Page -->
                    <b-col
                        cols="12"
                        md="4"
                        class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
                        <label>Mostrar</label>
                        <v-select
                            v-model="perPage"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="perPageOptions"
                            :clearable="false"
                            class="per-page-selector d-inline-block mx-50"
                        />
                        <label>registros</label>
                    </b-col>

                    <!-- Search -->
                    <b-col
                        cols="12"
                        md="6"
                        class="ml-auto">
                        <div class="d-flex">
                            <b-form-input
                                v-model="searchQuery"
                                class="d-inline-block mr-1"
                                placeholder="Buscar testimonio ..."
                                trim
                            />
                        </div>
                    </b-col>
                </b-row>

            </div>

            <b-alert variant="info" :show="true" class="mx-2">
                <div class="alert-body">
                    Los testimonios se seleccionan desde la
                    <b-link class="alert-link" :to="{ name: 'surveys' }">Lista de encuestas</b-link>,
                    marcando una encuesta como testimonio. Aquí se define cómo se publican en la web.
                </div>
            </b-alert>

            <b-table
                ref="refTestimonialListTable"
                class="position-relative"
                :style="totalTestimonials < 3 && totalTestimonials > 0 ? 'height: 250px' : 'height: inherit'"
                :items="fetchTestimonials"
                responsive
                :fields="tableColumns"
                primary-key="id"
                :sort-by.sync="sortBy"
                show-empty
                empty-text="No se encontraron registros coincidentes"
                :sort-desc.sync="isSortDirDesc">

                <template #cell(testimonial_order)="data">
                    <span v-if="data.item.testimonial_order !== null">{{ data.item.testimonial_order }}</span>
                    <span v-else class="text-muted">-</span>
                </template>

                <template #cell(display_name)="data">
                    <b-link
                        :to="{ name: 'testimonials-edit', params: { id: data.item.id } }"
                        class="font-weight-bold d-block text-nowrap">
                        {{ data.item.display_name }}
                    </b-link>
                    <small v-if="data.item.is_anonymous" class="text-muted">Publicado como anónimo</small>
                    <small v-else-if="data.item.testimonial_alias" class="text-muted">Alias</small>
                </template>

                <template #cell(is_anonymous)="data">
                    <b-badge
                        pill
                        :variant="data.item.is_anonymous ? 'light-primary' : 'light-secondary'"
                    >
                        {{ data.item.is_anonymous ? 'Sí' : 'No' }}
                    </b-badge>
                </template>

                <template #cell(score)="data">
                    <div class="item-meta" v-if="data.item.score">
                        <ul class="unstyled-list list-inline mb-25">
                            <li
                                v-for="star in 5"
                                :key="star"
                                class="ratings-list-item"
                            >
                                <feather-icon
                                    icon="StarIcon"
                                    size="18"
                                    class="mr-25"
                                    :class="[{'fill-current': star <= data.item.score}, star <= data.item.score ? 'text-warning' : 'text-muted']"
                                />
                            </li>
                        </ul>
                    </div>
                    <span v-else class="text-muted">Sin puntaje</span>
                </template>

                <template #cell(comments)="data">
                    <span v-if="data.item.comments">{{ data.item.comments.length > 60 ? data.item.comments.substring(0, 60) + '...' : data.item.comments }}</span>
                    <span v-else class="text-muted">-</span>
                </template>

                <template #cell(completion_date)="data">
                    {{ data.item.completion_date ? moment(data.item.completion_date).format('DD/MM/YYYY') : '-' }}
                </template>

                <template #cell(testimonial_active)="data">
                    <b-badge
                        pill
                        :variant="isVisible(data.item) ? 'light-success' : 'light-danger'"
                    >
                        {{ isVisible(data.item) ? 'Visible' : 'Oculto' }}
                    </b-badge>
                </template>

                <template #cell(actions)="data">
                    <b-dropdown
                        variant="link"
                        no-caret
                        :right="$store.state.appConfig.isRTL">

                        <template #button-content>
                            <feather-icon
                                icon="MoreVerticalIcon"
                                size="16"
                                class="align-middle text-body"
                            />
                        </template>

                        <b-dropdown-item :to="{ name: 'testimonials-edit', params: { id: data.item.id } }">
                            <feather-icon icon="EditIcon" />
                            <span class="align-middle ml-50">Editar</span>
                        </b-dropdown-item>

                        <b-dropdown-item
                            v-if="!isVisible(data.item)"
                            @click="activateTestimonial(data.item.id)"
                        >
                            <feather-icon icon="EyeIcon" />
                            <span class="align-middle ml-50">Mostrar en la web</span>
                        </b-dropdown-item>

                        <b-dropdown-item
                            v-else
                            @click="desactivateTestimonial(data.item.id)"
                        >
                            <feather-icon icon="EyeOffIcon" />
                            <span class="align-middle ml-50">Ocultar de la web</span>
                        </b-dropdown-item>
                    </b-dropdown>
                </template>

            </b-table>
            <div class="mx-2 mb-2">
                <b-row>

                    <b-col
                        cols="12"
                        sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-start">
                        <span class="text-muted">Mostrando {{ dataMeta.from }} al {{ dataMeta.to }} de {{ dataMeta.of }} registros</span>
                    </b-col>

                    <b-col
                        cols="12"
                        sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-end">

                        <b-pagination
                            v-model="currentPage"
                            :total-rows="totalTestimonials"
                            :per-page="perPage"
                            first-number
                            last-number
                            class="mb-0 mt-1 mt-sm-0"
                            prev-class="prev-item"
                            next-class="next-item">

                            <template #prev-text>
                                <feather-icon
                                    icon="ChevronLeftIcon"
                                    size="18"
                                />
                            </template>
                            <template #next-text>
                                <feather-icon
                                    icon="ChevronRightIcon"
                                    size="18"
                                />
                            </template>
                        </b-pagination>

                    </b-col>

                </b-row>
            </div>
        </b-card>
    </div>
</template>

<script>

    import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
    import { useToast } from 'vue-toastification/composition';
    import testimonialStoreModule from '../testimonialStoreModule';
    import useTestimonialsList from './useTestimonialsList';
    import { onUnmounted } from '@vue/composition-api';
    import vSelect from 'vue-select';
    import store from '@/store';
    import moment from 'moment';

    export default {
        components: {
            vSelect
        },
        data() {
            return {
                moment
            }
        },
        setup() {

            // USE TOAST
            const toast = useToast();

            const TESTIMONIAL_APP_STORE_MODULE_NAME = 'app-testimonial';

            // REGISTER MODULE
            if (!store.hasModule(TESTIMONIAL_APP_STORE_MODULE_NAME)) store.registerModule(TESTIMONIAL_APP_STORE_MODULE_NAME, testimonialStoreModule);

            // UNREGISTER ON LEAVE
            onUnmounted(() => {
                if (store.hasModule(TESTIMONIAL_APP_STORE_MODULE_NAME)) store.unregisterModule(TESTIMONIAL_APP_STORE_MODULE_NAME);
            });

            const {
                fetchTestimonials,
                tableColumns,
                perPage,
                currentPage,
                totalTestimonials,
                dataMeta,
                perPageOptions,
                searchQuery,
                sortBy,
                isSortDirDesc,
                refTestimonialListTable,

                refetchData
            } = useTestimonialsList();

            // Los registros anteriores a la columna testimonial_active llegan como
            // null y se consideran visibles, igual que en el endpoint público.
            const isVisible = (item) => item.testimonial_active === null || item.testimonial_active === undefined || Boolean(item.testimonial_active);

            const showToast = (title, icon, variant) => {
                toast({
                    component: ToastificationContent,
                    props: { title, icon, variant }
                });
            };

            const activateTestimonial = (id) => {
                store.dispatch('app-testimonial/activateTestimonial', { id })
                    .then(response => {
                        showToast(response.data.message, 'CheckIcon', 'success');
                        refetchData();
                    })
                    .catch(() => showToast('Error al publicar el testimonio.', 'AlertTriangleIcon', 'danger'));
            };

            const desactivateTestimonial = (id) => {
                store.dispatch('app-testimonial/desactivateTestimonial', { id })
                    .then(response => {
                        showToast(response.data.message, 'CheckIcon', 'success');
                        refetchData();
                    })
                    .catch(() => showToast('Error al ocultar el testimonio.', 'AlertTriangleIcon', 'danger'));
            };

            return {
                fetchTestimonials,
                tableColumns,
                perPage,
                currentPage,
                totalTestimonials,
                dataMeta,
                perPageOptions,
                searchQuery,
                sortBy,
                isSortDirDesc,
                refTestimonialListTable,

                refetchData,

                isVisible,
                activateTestimonial,
                desactivateTestimonial
            }
        }
    }

</script>

<style lang="scss" scoped>

    .per-page-selector {
        width: 90px;
    }

</style>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
